// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2V2FA","left":"styles_left__e8ajV","desktopActions":"styles_desktopActions__J4YYC","title":"styles_title__13Fss"};